import * as React from 'react';
import { BaSeInput, BaSeCheckbox, BaSeGrid, BaSeGridItem } from '@base/react';
import { CheckAtivoContainer } from '../create-form-styled';
import { Dragger } from '../../shared/upload/dragger';

export const LinksAndImagesSection = ({
  formData,
  imageState,
  isCompleteForm,
  uiState,
  onFieldChange,
  onShowImageCapaModal,
  onShowImageCardModal,
}) => {
  return (
    <>
      {isCompleteForm && (
        <>
          <BaSeGrid>
            <BaSeGridItem tablet={{ size: 7 }}>
              <BaSeInput
                complement=""
                label="Link de acesso no Whatsapp"
                subLabel="Opcional"
                onChange={(e) => onFieldChange('linkWhatsapp', e)}
                placeholder="Digite o link de acesso ao produto"
                textError="Informar erro de preenchimento"
                value={formData.linkWhatsapp}
              />
            </BaSeGridItem>
            <BaSeGridItem tablet={{ size: 5 }}>
              <CheckAtivoContainer>
                <BaSeCheckbox
                  align="top-left"
                  color="default"
                  label="Exige login prévio"
                  checked={formData.isLoginWhatsapp}
                  onChange={() =>
                    onFieldChange('isLoginWhatsapp', !formData.isLoginWhatsapp)
                  }
                  size="medium"
                />
              </CheckAtivoContainer>
            </BaSeGridItem>
          </BaSeGrid>
          <BaSeGrid>
            <BaSeGridItem tablet={{ size: 7 }}>
              <BaSeInput
                label="Link de acesso no Telegran"
                subLabel="Opcional"
                onChange={(e) => onFieldChange('linkTelegran', e)}
                placeholder="Digite o link de acesso ao produto"
                value={formData.linkTelegran}
              />
            </BaSeGridItem>
            <BaSeGridItem tablet={{ size: 5 }}>
              <CheckAtivoContainer>
                <BaSeCheckbox
                  align="top-left"
                  color="default"
                  label="Exige login prévio"
                  checked={formData.isLoginTelegran}
                  onChange={() =>
                    onFieldChange('isLoginTelegran', !formData.isLoginTelegran)
                  }
                  size="medium"
                />
              </CheckAtivoContainer>
            </BaSeGridItem>
          </BaSeGrid>
          <BaSeInput
            label="URL do video de marketing"
            complement="Coloque uma URL válida. ex: https://www.exemplo.com/"
            subLabel="Opcional"
            placeholder="Digite a url do video de marketing para a vitrine"
            typeInput="url"
            inputMode="url"
            value={formData.url}
            onChange={(e) => onFieldChange('url', e)}
          />
        </>
      )}
      <BaSeGrid>
        {isCompleteForm && (
          <BaSeGridItem size={6}>
            <Dragger
              subLabel="Opcional"
              image={imageState.imagem}
              setImage={onShowImageCapaModal}
              isLoadingImage={imageState.loadingImage}
              label="Imagem da capa"
              sizeImg="568px x 304px"
              isClear={uiState.isNovoProduto}
            />
          </BaSeGridItem>
        )}
        <BaSeGridItem size={isCompleteForm ? 6 : 12}>
          <Dragger
            subLabel="Opcional"
            image={imageState.imagemCard}
            setImage={onShowImageCardModal}
            isLoadingImage={imageState.loadingImage}
            label="Imagem de card"
            sizeImg="330px x 315px"
            isClear={uiState.isNovoProduto}
          />
        </BaSeGridItem>
      </BaSeGrid>
    </>
  );
};
